export const SET_IS_MOBILE_SCREEN = 'store/page/SET_IS_MOBILE_SCREEN';
export const SET_IS_LARGE_SCREEN = 'store/page/SET_IS_LARGE_SCREEN';
export const SET_SCREEN_SIZE = 'store/page/SET_SCREEN_SIZE';
export const SET_IS_LOGIN = 'store/page/SET_IS_LOGIN';
export const SET_PAGE_LOGIN_DATA = 'store/page/SET_PAGE_LOGIN_DATA';
export const SET_PAGE_DAC_LOGIN_DATA = 'store/page/SET_PAGE_DAC_LOGIN_DATA';
export const SET_IS_STATUS = 'store/page/SET_IS_STATUS';
export const SET_VISIBLE_GLOBAL_ERROR_MODAL = 'store/page/SET_VISIBLE_GLOBAL_ERROR_MODAL';
export const SET_POPUP_ADDS = 'store/page/SET_POPUP_ADDS';

export interface IPopUpAdds {
  isShown?: boolean;
  urlRedirect?: string;
}
